// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"StoriesArchiveSection_subtitle__JEo5b"};